import { useEffect, useState } from "react";

export default function StickyCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-50/95 backdrop-blur border-t border-background-200 px-3 py-2 flex gap-2">
      <a
        href="tel:0120024747"
        className="flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm whitespace-nowrap cursor-pointer transition-colors"
      >
        <i className="ri-phone-fill"></i>電話で相談
      </a>
      <a
        href="https://lin.ee/xf3zQex"
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-sm whitespace-nowrap cursor-pointer transition-colors"
      >
        <i className="ri-line-fill"></i>LINE相談
      </a>
    </div>
  );
}